import { faComment } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import i18n from "../../../../constants/i18n";
import getUserMessageIdStore from "../../../../stores/user-store/message-id-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import React from "react";
import { isPositiveNumber } from "et3-type-guards";
import Et3Button from "../../../../core/et3-button";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";

const UserMessagesIdForm = withLiteObserverAndTheme(() => {
  const messageId = getUserMessageIdStore().messageIdInput.get();

  const isEnable = isPositiveNumber(messageId);
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        type={"number"}
        icon={faComment}
        label={i18n.get("MESSAGE_ID")}
        placeHolder={i18n.get("MESSAGE_ID")}
        value={getUserMessageIdStore().messageIdInput.get()}
        onChoose={(value: number) => {
          getUserMessageIdStore().messageIdInput.set(value);
        }}
        onBlur={() => {}}
        onEnter={async () => {
          await getUserMessageIdStore().getUserMessagesByMessageID();
          navigate({
            pathname: window.location.pathname,
            search: `?id=${getUserMessageIdStore().messageIdInput.get()}`
          });
        }}
        style={{}}
      />
      <Et3Picker
        label={i18n.get("MESSAGE_ERA")}
        options={[
          { label: "POST_2025", value: "POST_2025" },
          { label: "PRE_2025", value: "PRE_2025" }
        ]}
        value={getUserMessageIdStore().messageEra.get()}
        onChoose={(value: TEt3PickerSingleValue) => {
          getUserMessageIdStore().setMessageEra(value);
        }}
        isMultiple={false}
        style={{}}
        onEnter={() => {}}
        onClick={() => {}}
        containerStyle={{}}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={isEnable}
        onClick={async () => {
          await getUserMessageIdStore().getUserMessagesByMessageID();
          navigate({
            pathname: window.location.pathname,
            search: `?id=${getUserMessageIdStore().messageIdInput.get()}`
          });
        }}
        size="LARGE"
        type="GET"
        text="GET"
      />
    </React.Fragment>
  );
});
export default UserMessagesIdForm;
